import { isGuestEmail, isLifecycleGuest } from "./auth.helpers";
import type { AuthStore } from "./auth.types";

// Creates the initial state for the authentication store.
// This represents the default state before any authentication attempts or user data is loaded.
export const initialAuthStore = (): AuthStore => ({
  state: "loading",
  token: undefined,
  authenticatedUser: undefined,
});

// Checks if the user is currently in guest mode.
// Guest users have limited access and functionality compared to registered users.
export const getAuthIsGuest = (store: AuthStore) =>
  isLifecycleGuest(store.state) || isGuestEmail(store.authenticatedUser?.user.primaryEmail);
